"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecommendedAutomations = exports.useAssociations = exports.useAutomations = exports.useTriggersAndActions = void 0;
var axios_1 = __importDefault(require("axios"));
var swr_1 = __importDefault(require("swr"));
var immutable_1 = __importDefault(require("swr/immutable"));
var inversify_react_1 = require("inversify-react");
var useTriggersAndActions = function (query) {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var data = (0, immutable_1.default)(["".concat(apiBaseUrl, "/automations/").concat(query.integrationName, "/form"), query], function (_a) {
        var _b = __read(_a, 2), url = _b[0], query = _b[1];
        return fetchTriggersAndActions(url, { objectType: query.objectType });
    }).data;
    return data;
};
exports.useTriggersAndActions = useTriggersAndActions;
var fetchTriggersAndActions = function (url, query) { return __awaiter(void 0, void 0, Promise, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get(url, {
                    params: query,
                    withCredentials: true,
                })];
            case 1:
                result = _a.sent();
                return [2, result.data];
        }
    });
}); };
var createAutomation = function (apiBaseUrl, _a) {
    var name = _a.name, description = _a.description, triggerId = _a.triggerId, actions = _a.actions, integration = _a.integration, associations = _a.associations;
    return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, axios_1.default.post("".concat(apiBaseUrl, "/automations"), {
                        name: name,
                        description: description,
                        triggerId: triggerId,
                        actions: actions,
                        integration: integration,
                        associations: associations,
                    }, { withCredentials: true })];
                case 1:
                    response = _b.sent();
                    return [2, response.data];
            }
        });
    });
};
var updateAutomation = function (apiBaseUrl, _a) {
    var id = _a.id, name = _a.name, description = _a.description, triggerId = _a.triggerId, actions = _a.actions, integration = _a.integration, associations = _a.associations;
    return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, axios_1.default.patch("".concat(apiBaseUrl, "/automations/").concat(id), {
                        name: name,
                        description: description,
                        triggerId: triggerId,
                        actions: actions,
                        integration: integration,
                        associations: associations,
                    }, { withCredentials: true })];
                case 1:
                    response = _b.sent();
                    return [2, response.data];
            }
        });
    });
};
var enableAutomation = function (apiBaseUrl, id, enabled) {
    return axios_1.default.patch("".concat(apiBaseUrl, "/automations/").concat(id), {
        enabled: enabled,
    }, { withCredentials: true });
};
var deleteAutomation = function (apiBaseUrl, id) {
    return axios_1.default.delete("".concat(apiBaseUrl, "/automations/").concat(id), { withCredentials: true });
};
var transformAutomation = function (automation) {
    return __assign(__assign({}, automation), { actions: automation.actions.map(function (action) {
            return { actionId: action.actionId, selectedOptions: action.config };
        }) });
};
var useAutomations = function (query) {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var _a = (0, swr_1.default)(["".concat(apiBaseUrl, "/automations"), query], function (_a) {
        var _b = __read(_a, 1), url = _b[0];
        return fetchAutomations(url);
    }, {
        refreshInterval: 60000,
        revalidateIfStale: false,
        revalidateOnFocus: true,
        revalidateOnReconnect: true,
        revalidateOnMount: true,
    }), data = _a.data, mutate = _a.mutate, error = _a.error, isLoading = _a.isLoading;
    var create = function (automation) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, mutate(function (currentData) { return __awaiter(void 0, void 0, Promise, function () {
                        var newAutomation;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, createAutomation(apiBaseUrl, automation)];
                                case 1:
                                    newAutomation = _a.sent();
                                    if (currentData) {
                                        return [2, __spreadArray(__spreadArray([], __read(currentData), false), [transformAutomation(newAutomation)], false)];
                                    }
                                    return [2, [transformAutomation(newAutomation)]];
                            }
                        });
                    }); }, { revalidate: false })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var update = function (automation) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, mutate(function (currentData) { return __awaiter(void 0, void 0, Promise, function () {
                        var updatedAutomation;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, updateAutomation(apiBaseUrl, automation)];
                                case 1:
                                    updatedAutomation = _a.sent();
                                    return [2, currentData === null || currentData === void 0 ? void 0 : currentData.map(function (item) { return (item.id === automation.id ? transformAutomation(updatedAutomation) : item); })];
                            }
                        });
                    }); }, { revalidate: false })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var enable = function (id, enabled) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, mutate(function (currentData) { return __awaiter(void 0, void 0, Promise, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, enableAutomation(apiBaseUrl, id, enabled)];
                                case 1:
                                    _a.sent();
                                    return [2, currentData === null || currentData === void 0 ? void 0 : currentData.map(function (item) { return (item.id === id ? __assign(__assign({}, item), { enabled: enabled }) : item); })];
                            }
                        });
                    }); }, {
                        revalidate: false,
                    })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var remove = function (id) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, mutate(function (currentData) { return __awaiter(void 0, void 0, Promise, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, deleteAutomation(apiBaseUrl, id)];
                                case 1:
                                    _a.sent();
                                    return [2, currentData === null || currentData === void 0 ? void 0 : currentData.filter(function (item) { return item.id !== id; })];
                            }
                        });
                    }); }, { revalidate: false })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    return {
        data: data,
        error: error,
        create: create,
        update: update,
        enable: enable,
        remove: remove,
        isLoading: isLoading,
    };
};
exports.useAutomations = useAutomations;
var fetchAutomations = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get(url, {
                    withCredentials: true,
                })];
            case 1:
                response = _a.sent();
                return [2, response.data.data.map(transformAutomation)];
        }
    });
}); };
var useAssociations = function () {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var update = function (resourceId, associationsToBeAdded, resourceType) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, updateAssociation(apiBaseUrl, resourceId, associationsToBeAdded, resourceType)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    return { update: update };
};
exports.useAssociations = useAssociations;
var updateAssociation = function (apiBaseUrl, resourceId, associationsToBeAdded, resourceType) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.put("".concat(apiBaseUrl, "/automations/associations"), {
                    automationIds: associationsToBeAdded,
                    resourceId: resourceId,
                    resourceType: resourceType,
                }, { withCredentials: true })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
var useRecommendedAutomations = function () {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var data = (0, immutable_1.default)(["".concat(apiBaseUrl, "/automations/recommended")], function (_a) {
        var _b = __read(_a, 1), url = _b[0];
        return fetchRecommendedAutomations(url);
    }).data;
    return { data: data };
};
exports.useRecommendedAutomations = useRecommendedAutomations;
var fetchRecommendedAutomations = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get(url, {
                    withCredentials: true,
                })];
            case 1:
                result = _a.sent();
                return [2, result.data];
        }
    });
}); };
